import ChatContainer from "./blocks/ChatContainer";
import PageContent from "../PageContent";
import ConversationSidebar from "@/components/content-sidebar/conversation-sidebar";
import { Domain, getDomain } from "@/utils/domain";
import TenantSpecificDialog from "@/components/dialogs/tenant-specific-dialog";
import { useChatConversationRoute } from "./hooks/useChatConversationRoute";

const ChatView = () => {
  const { isRestoringConversation } = useChatConversationRoute();

  return (
    <PageContent
      title={
        getDomain(window.location.hostname) === Domain.LODA
          ? "Loda AI"
          : "Lara AI"
      }
      rightSidebar={<ConversationSidebar />}
    >
      {/* Automatically shows dialog for tenants configured in tenantDialogs.tsx */}
      <TenantSpecificDialog />
      <ChatContainer isRestoringConversation={isRestoringConversation} />
    </PageContent>
  );
};

export default ChatView;
